import React, { FC } from 'react';
import SplitPayeePayerScene from './split-payee-scene';
import useSplitPayeePayers from './split-payee-hooks';
import { OrderEntryPartyContent } from './services';
import { SplitPayeePayerProps } from './types';
import { useParams } from 'react-router-dom';

export const SplitPayeePayer: FC<SplitPayeePayerProps> = ({
  open,
  onClose,
  onSuccess,
  charges,
  kind,
  letter,
  hideAtClosingAmount,
  hideBeforeClosingAmount,
  accountingEntry
}) => {
  const { methods, parties, updateLedgerEntryParties, loadingSave, errors,
    deleteRoles
  } =
    useSplitPayeePayers(onSuccess, charges);

  const { id: orderId } = useParams<{ id: string }>();

  const handleSave = (
    data: {
      accounting_id: string;
      parties: OrderEntryPartyContent[];
    }[]
  ) => {
    updateLedgerEntryParties({ id: orderId, data });
  };

  const handleDelete = (accountingIds: string[]) => {
    deleteRoles({ id: orderId, role: kind, accountingIds });
  };

  return (
    <SplitPayeePayerScene
      open={open}
      onClose={onClose}
      charges={charges}
      accountingEntry={accountingEntry}
      orderParties={parties}
      methods={methods}
      hideAtClosingAmount={hideAtClosingAmount}
      hideBeforeClosingAmount={hideBeforeClosingAmount}
      handleSave={handleSave}
      loadingSave={loadingSave}
      kind={kind}
      errors={errors}
      letter={letter}
      handleDelete={handleDelete}
    />
  );
};
